import React, {PureComponent, useEffect, useCallback, useState} from 'react';
import {connect, useSelector, useDispatch} from 'react-redux';
import moment from 'moment';
import {getServiceTimes} from '../actions/serviceTimes';


function formatTime(time) {
  return moment(`2019-01-01T${time}`).format('h:mma');
}


export default function ServiceTimeInput({onChange}) {
  const dispatch = useDispatch();
  const serviceTimes = useSelector(state => state.serviceTimes.data);
  const congregationId = useSelector(state => state.congregations.selected);
  const day = useSelector(state => state.visit.date);
  const [congregationServiceTimes, setCongregationServiceTimes] = useState([]);

  useEffect(() => {
    dispatch(getServiceTimes());
  }, []);

  useEffect(() => {
    if (congregationId && day) {
      const dow = moment(day).format('dddd');
      setCongregationServiceTimes(
        serviceTimes.filter(i => i.Congregation_ID === congregationId && i.Day == dow)
      );
    }
    else {
      setCongregationServiceTimes([]);
    }
  }, [day, serviceTimes, congregationId]);

  const changeHandler = useCallback(event => {
    onChange(JSON.parse(event.target.value));
  }, [onChange]);

  return (
    <select className="service-times-input" onChange={changeHandler}>
      <option value="null">Service Time</option>
        {congregationServiceTimes.map(i =>
          <option value={JSON.stringify(i.Service_Time_ID)} key={i.Service_Time_ID}>{formatTime(i.Service_Time)}</option>
        )}
    </select>
  );
}


// @connect(
//   state => ({
//     serviceTimes: state.serviceTimes.data,
//     congregationId: state.congregations.selected,
//     day: state.visit.date
//   }),
//   dispatch => ({
//     getServiceTimes() {
//       dispatch(getServiceTimes());
//     }
//   })
// )
// export default class ServiceTimeInput extends PureComponent {
//   componentDidMount() {
//     this.props.getServiceTimes();
//   }

//   render() {
//     const {serviceTimes, congregationId, day} = this.props;
//     const congregationServiceTimes = congregationId ? serviceTimes.filter(i => i.Congregation_ID === congregationId && i.Meeting_Day_ID === day) : [];

//     return (
//       <select className="service-times-input" onChange={this._onChange}>
//         <option value="null">Service Time</option>
//         {congregationServiceTimes.map(i =>
//           <option value={JSON.stringify(i.Service_Time_ID)} key={i.Service_Time_ID}>{formatTime(i.Service_Time)}</option>
//         )}
//       </select>
//     );
//   }

//   _onChange = (event) => {
//     this.props.onChange(JSON.parse(event.target.value));
//   }
// }


// WEBPACK FOOTER //
// ./src/components/ServiceTimeInput.js